module.exports = __webpack_public_path__ + "media/assets/images/flags/ua-d7652afd7e1b428689009dbd806f9d74.svg";